<div class="not-authorized">
    <p class="lato-16-b-vw message">{{ message }}</p>
    <button class="btn btn-primary btn-lg" (click)="navigateHome()">
        Back To Home
    </button>
</div>